import React from 'react'

export default function Footer() {
  return (
    <div>
<footer className="bg-white text-center text-black mt-5 ">
  <div className="container p-2">
    <section className="">
      <form action="">
        <div className="row d-flex justify-content-center">
          <div className="col-auto">
            <p className="pt-2">
              <strong>Sign up for weather alerts</strong>
            </p>
          </div> 
          <div className="col-md-5 col-12">
            <div className="form-outline form-black mb-0">
              <input type="email" id="form5Example21" className="form-control" placeholder="Email "/>
            </div>
          </div>
   
          <div className="col-auto">
            <button type="submit" className="btn btn-outline-warning" id='ButtonSub' >
              Subscribe
            </button>
          </div>
        </div>
      </form>
    </section>
  </div>
  <div className="text-center p-3" style={{backgroundColor: "#A9A9A9"}}>
    © 2022 Copyright 
    <a className="text-white" style={{textDecoration:"none"}} href="#"> WEATHER.com</a>
  </div>
</footer>
    </div>
  )
}
